const n = {
  name: "Refund",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 10V3H5V6.34344C6.64928 4.30582 9.16914 3 12 3C16.9723 3 21 7.02772 21 12C21 16.9723 16.9723 21 12 21C7.02771 21 3 16.9723 3 12H5C5 15.8677 8.13229 19 12 19C15.8677 19 19 15.8677 19 12C19 8.13228 15.8677 5 12 5C9.62134 5 7.5212 6.18596 6.25449 8H10V10H3Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as Refund
};
